import http from "@/utils/request";

const taxSubAccountApi = {
  pageQuery: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxSubAccount.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default taxSubAccountApi;
